import React from 'react';

interface SearchBarSkeletonProps {
  className?: string;
}

const SearchBarSkeleton: React.FC<SearchBarSkeletonProps> = ({
  className = '',
}) => {
  return (
    <div
      className={`bg-white border border-gray-200 rounded-lg shadow-sm ${className}`}
    >
      <div className="p-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          {/* Search Section */}
          <div className="flex-1">
            <div className="relative">
              <div className="h-12 bg-gray-200 rounded-lg animate-pulse w-full"></div>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden lg:block h-8 w-px bg-gray-300"></div>

          {/* Results Per Page Section */}
          <div className="flex items-center gap-3">
            <div className="h-4 bg-gray-200 rounded animate-pulse w-8"></div>
            <div className="h-12 bg-gray-200 rounded-lg animate-pulse w-20"></div>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBarSkeleton;
